import React from "react";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
// import BannerSectionStyle4 from '../Section/BannerSection/BannerSectionStyle4';
import TeamSectionStyle2 from "../Section/TeamSection/TeamSectionStyle2";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import { Helmet } from "react-helmet";
const teamData = [
  {
    imgUrl: "/images/doctors/Hyper-Hypothermia Unit.png",
    department: "Hyper-Hypothermia Unit (Patent applied for)",

    description:
      "Efficiently manages body temperature with advanced control features, offering precise heating and cooling for optimal patient care and comfort.",

    category: "Hyper-Hypothermia Unit ",
    href: "/HyperHypothermiaUnit",
  },
  {
    imgUrl: "/images/doctors/Hyper-Hypothermia Unit 1 Plus.png",
    department: "Hyper Hypothermia Unit Plus (Patent applied for)",

    description:
      "Mercury Hyper-Hypothermia 1 Plus machine comes equipped with an advanced Wi-Fi remote controller with a 10-meter range, allowing seamless and efficient operation from a distance. ",

    category: "Hyper-Hypothermia Unit ",
    href: "/HyperHypothermiaUnitplus",
  },
  {
    imgUrl: "/images/doctors/MERCURY MINI.png",
    department: "Mercury Mini",

    description:
      "Portable heater with touch <br/> screen control, offering precise<br/> temperature management and a 5-liter capacity for effective patient care.",

    category: "Mercury Mini",
    href: "/MercuryMini",
  },
  {
    imgUrl: "/images/doctors/Mercury Care.png",
    department: "Mercury Care",

    description:
      "Mercury Care is Heater-Cooler Unit. Care is used to maintain the body temperature through conductive heat transfer. The conductive heat transfer is accomplished through blanket under the patient. The user regulates the desired fluid temperature with continuous monitoring",

    category: "Mercury Care",
    href: "/Mercurycare",
  },
  {
    imgUrl: "/images/doctors/Mercury Magma.png",
    department: "Mercury Magma",

    description:
      "Versatile heater with touch <br/> screen control, featuring <br/>  a 5-litercapacity and a temperature range of 42° to 55°C for efficient performance.",

    category: "Mercury Magma",
    href: "/MercuryMagma",
  },
  {
    imgUrl: "/images/doctors/Mercury Slush.png",
    department: "Mercury Slush",

    description:
      "Efficient slush unit with auto-stir, minimizing tissue trauma and simplifying operation, designed for easy maintenance and silent performance.",

    category: "Mercury Slush",
    href: "/MercurySlush",
  },
  {
    imgUrl: "/images/doctors/Mercury-S1-Sternum-Saw.png",
    department: "Mercury-S1-Sternum-Saw",

    description:
      "Precision surgical saw with quick-release blades, ensuring exceptional control, easy sterilization, and minimal tissue impact for optimal performance.",

    category: "Mercury-S1 Surgical Saw",
    href: "/Mercury-S1-Sternum-Saw",
  },
  {
    imgUrl: "/images/doctors/Mercury Micro.png",
    department: "Mercury Micro",

    description:
      "The unit features a touch display, PLC-based electronics, 230V/50Hz operation, 3L closed tank, 5L/min flow, and weighs approx. 12kg (38x25.5x19.5 cm).",

    category: "Mercury Micro",
    href: "/MercuryMicro",
  },
];

export default function Products() {
  pageTitle("Doctors");
  return (
    <>
      <Helmet>
        <title>
          Mercury Healthcare – Advanced Medical Equipment for Optimal Patient
          Care | Manufacturer & Supplier
        </title>
        <meta
          name="description"
          content="Explore Mercury Healthcare’s precision-engineered medical devices, including heater-cooler units, surgical saws, and slush machines for superior patient care."
        />
        {/* Google Tag (gtag.js) */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-MGF4V7P4YB"
        ></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-MGF4V7P4YB');
          `}
        </script>
      </Helmet>

      <BannerSectionStyle5
        bgUrl="/images/doctors/banner_bg.svg"
        //  imgUrl="/images/doctors/Product Banner2 899x560 (4).png"
        imgUrl="/images/doctors/Product Banner2 899x560 (1).png"
        title="Advanced Tools for Optimal Care"
        subTitle="Discover Mercury Healthcare's precision-engineered medical equipment, designed for reliability, efficiency, and superior patient care."
      />
      <Section topMd={65} bottomMd={200} bottomLg={150} bottomXl={110}>
        <TeamSectionStyle2 data={teamData} />
      </Section>
      {/* <Section className="cs_footer_margin_0">
        <BannerSectionStyle4
          bgUrl="images/doctors/banner_bg_2.jpeg"
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
        />
      </Section> */}
    </>
  );
}
